(ns net.kestec.mhda-pilgrimage.routes
  (:require
    [re-frame.core :as rf]
    [reitit.coercion.spec :as coercion-spec]
    [reitit.core :as reitit]

    [net.kestec.mhda-pilgrimage.db :as db]
    [net.kestec.mhda-pilgrimage.auth.auth-events :as auth-events]
    [net.kestec.mhda-pilgrimage.public.application.application-events :as application-events]
    [net.kestec.mhda-pilgrimage.public.applications.applications-events :as applications-events]
    [net.kestec.mhda-pilgrimage.admin.applications.applications-events :as admin-applications-events]
    [net.kestec.mhda-pilgrimage.admin.applications.application-events :as admin-application-events]
    [net.kestec.mhda-pilgrimage.admin.applications.application-detail :as admin-application-detail]
    [net.kestec.mhda-pilgrimage.admin.cms.cms-events :as admin-cms-events]
    [net.kestec.mhda-pilgrimage.route :as route]
    [net.kestec.mhda-pilgrimage.public.landing :as landing]
    [net.kestec.mhda-pilgrimage.public.dashboard :as dashboard]
    [net.kestec.mhda-pilgrimage.test.form-test :as form-test]
    [net.kestec.mhda-pilgrimage.public.application.application-form :as application-form]

    [net.kestec.mhda-pilgrimage.admin.dashboard :as admin-dashboard]
    [net.kestec.mhda-pilgrimage.admin.setup :as admin-setup]
    [net.kestec.mhda-pilgrimage.admin.cms.news-edit :as news-edit]

    [net.kestec.mhda-pilgrimage.admin.application-list :as admin-application-list]
    [net.kestec.mhda-pilgrimage.admin.log-list :as admin-log-list]
    ))

(def router
  (reitit/router
    [["" {:controllers [{:start    #(rf/dispatch [::db/init])
                         :identity (fn [match]
                                     ;; Re-runs whenever the value returned here changes
                                     (get-in [match] [::db/selected-application]))}]}
      ["/" {:name ::route/public.landing}]
      ["/dashboard" {:name        ::route/dashboard
                     :controllers [{:start #(rf/dispatch [::applications-events/load-applications])}]}]
      ["/pilgrimage/:pilgrimage-id"
       ["/application/:application-id" {:controllers [{:start #(rf/dispatch [::application-events/load-application])}]}
        ["/form" {:name ::route/onboarding-form}]]]

      ["/admin/dashboard" {:name        ::route/admin.dashboard
                           :controllers [{:start #(rf/dispatch [::auth-events/load-me-and ::admin-applications-events/load-dashboard])}]}]

      ["/admin/application-list" {:name        ::route/admin.application-list
                                  :controllers [{:start #(rf/dispatch [::auth-events/load-me-and ::admin-applications-events/load-applications])}]}]

      ["/admin/setup" {:name        ::route/admin.setup
                       :controllers [{:start #(rf/dispatch [::auth-events/load-me-and ::admin-cms-events/admin-cms-load-setup])}]}]

      ["/admin/news/:news-id" {:name        ::route/admin.news-edit
                               :controllers [{:start #(rf/dispatch [::auth-events/load-me-and ::admin-cms-events/admin-cms-load-setup])}]}]

      ["/admin/application/:application-id" {:name        ::route/admin.application-detail
                                             :controllers [{:start #(rf/dispatch [::auth-events/load-me-and ::admin-application-events/reload-actual-and-list])}]}]

      ["/admin/log-list" {:name ::route/admin.log-list}]
      ["/form-test" {:name ::route/test.form}]
      ]]
    {:data {:coercion coercion-spec/coercion}}))

(defmethod route/content :default [match]
  [:div
   [:h1 "Unmatched route: " (pr-str match)]
   [:pre (pr-str match)]])


(defmethod route/content ::route/public.landing [_]
  [landing/main])


(defmethod route/content ::route/dashboard [_]
  [dashboard/main])



(defmethod route/content ::route/admin.dashboard [_]
  [admin-dashboard/main])

(defmethod route/content ::route/admin.application-list [_]
  [admin-application-list/main])

(defmethod route/content ::route/admin.log-list [_]
  [admin-log-list/main])

(defmethod route/content ::route/admin.setup [_]
  [admin-setup/main])

(defmethod route/content ::route/admin.news-edit [_]
  [news-edit/editNewsPage])

(defmethod route/content ::route/admin.application-detail [_]
  [admin-application-detail/main])

(defmethod route/content ::route/test.form [_]
  [form-test/main])

(defmethod route/content ::route/onboarding-form [_]
  [application-form/main])
